module.exports = __webpack_public_path__ + "img/black.d8f9165f.svg";